__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "diana";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@diana/core", "1.3.654", () => (Promise.all([__webpack_require__.e(736), __webpack_require__.e(368), __webpack_require__.e(170), __webpack_require__.e(330), __webpack_require__.e(349), __webpack_require__.e(994), __webpack_require__.e(66)]).then(() => (() => (__webpack_require__(55790))))));
			register("@mui/material", "5.14.11", () => (Promise.all([__webpack_require__.e(736), __webpack_require__.e(368), __webpack_require__.e(170), __webpack_require__.e(349)]).then(() => (() => (__webpack_require__(71244))))));
			register("@mui/styled-engine", "5.14.11", () => (Promise.all([__webpack_require__.e(736), __webpack_require__.e(330)]).then(() => (() => (__webpack_require__(16215))))));
			register("@tanstack/react-query", "5.62.0", () => (Promise.all([__webpack_require__.e(736), __webpack_require__.e(368)]).then(() => (() => (__webpack_require__(91700))))));
			register("react-dom", "18.2.0", () => (() => (__webpack_require__(73935))), 1);
			register("react-router-dom", "6.19.0", () => (Promise.all([__webpack_require__.e(736), __webpack_require__.e(170)]).then(() => (() => (__webpack_require__(49818))))));
			register("react/jsx-dev-runtime", "18.2.0", () => (() => (__webpack_require__(34862))), 1);
			register("react/jsx-runtime", "18.2.0", () => (() => (__webpack_require__(85893))), 1);
			register("react", "18.2.0", () => (() => (__webpack_require__(67294))), 1);
			register("styled-components", "5.3.5", () => (__webpack_require__.e(736).then(() => (() => (__webpack_require__(12788))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};